import { getApplicationSettings } from "owa-application-settings";
import type { MailboxInfo } from "owa-client-types";
import { isOfflineSyncEnabled } from "./isOfflineSyncEnabled";
import { isOfflineSearchIndexingEnabled } from "./isOfflineSearchIndexingEnabled";

export function isOfflineSearchEnabled(mailboxInfo: MailboxInfo): boolean {
    return (getApplicationSettings("PlatformType").isMonarch &&
        isOfflineSyncEnabled(mailboxInfo) &&
        isOfflineSearchIndexingEnabled() &&
        !!Intl.Segmenter);
}
